import { useState, useEffect } from 'react';
import styles from './ImageComponent.module.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ImageIcon } from '../../assets/image.svg';
import { ReactComponent as BrokenImage } from '../../assets/brokenImage.svg';


export const ImageComponent = ({ url, onClick }) => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [avifSupported, setAvifSupported] = useState(true); 

  const checkAVIFSupport = async () => {
    try {
      const img = new Image();
      img.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgABogQEAwgMg8f8D///8WfhwB8+ErK42A=';
      await img.decode();
      return true;
    } catch {
      console.log('Script: AVIF format is not supported by this browser.');
      return false;
    }
  };

  useEffect(() => {
    checkAVIFSupport().then((supported) => {
      setAvifSupported(supported);
    });
  }, []);


  const handleImageLoad = () => {
    setLoaded(true);
  };

  if (!avifSupported) {
    return (
      <div className={styles.unsupportedMessage}>
        <BrokenImage />
        <h4>{t('Image error')}</h4>
        <p>{t('Please update your browser')}</p>
      </div>
    );
  }

  return (
    <div className={`${styles.imageContainer} ${loaded ? styles.loaded : ''}`}>
      
      {!loaded ? <div className={styles.skeletonCard}>
        <ImageIcon />
      </div> : null}
      
      <img
        src={url}
        alt="Content"
        loading="lazy"
        onLoad={handleImageLoad}
        onError={(e) => {
          console.log('Image failed to load:', e);
          e.target.onerror = null; // Prevents infinite loop in case of broken image
          setAvifSupported(false); // Set to false if image fails to load
        }}
        className={styles.contentImage}
        onClick={() => onClick(true)}
      />
    
    </div>
  );
};